import { render, staticRenderFns } from "./ProcessAllot.vue?vue&type=template&id=6bbb963f&scoped=true"
import script from "./ProcessAllot.vue?vue&type=script&lang=js"
export * from "./ProcessAllot.vue?vue&type=script&lang=js"
import style0 from "./ProcessAllot.vue?vue&type=style&index=0&id=6bbb963f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bbb963f",
  null
  
)

export default component.exports